import React, { useCallback } from "react";
import PersonDetailPage from "./components/PersonDetailPage";
import { useNetworkPermissions, useNetworkService } from "./hooks/useNetworkRecords";
import { PARTNERS_HOME } from "./constants/networkEndpoints";

const CONFIG = { noun: "Partner", plural: "Partners", home: PARTNERS_HOME, canEditRecords: true };

/** /partner/network/partners/:Id */
const PartnerDetailPage = () => {
  const service = useNetworkService();
  const permissions = useNetworkPermissions();
  const load = useCallback(() => service.listPartners(), [service]);
  const remove = useCallback((id) => service.removePartner(id), [service]);

  return <PersonDetailPage config={CONFIG} load={load} remove={remove} permissions={permissions} />;
};

export default PartnerDetailPage;
